<!--
 * @Author: cryi.liu
 * @Date: 2020-05-06 11:17:14
 * @LastEditTime: 2020-06-17 11:23:38
 * @Description: 原 PSS 风格按钮
 -->
<template>
  <router-link
    :to="to ? to : ''"
    class="pss__button"
    :class="disabled ? 'disabled' : ''">
    <span @click="emitClick">{{ text }}</span>
  </router-link>
</template>

<script>
export default {
  name: 'PssButton',
  props: {
    text: { type: String, required: true },
    to: { type: String, required: false },
    disabled: { type: Boolean, required: false },
  },
  methods: {
    emitClick() {
      if (!this.disabled) {
        this.$emit('on-click');
      }
    },
  },
};
</script>

<style lang="less" scoped>
.pss__button {
  display: inline-block;
  height: 26px;
  line-height: 26px;
  padding-left: 2px;
  background: url('../../assets/image/bg-button@pss.jpg') left 0;
  color: @font-primary-color;

  &:hover {
    color: @font-primary-color;
    background-image: url('../../assets/image/bg-button-hover@pss.jpg');
  }

  &:active {
    color: @font-primary-color;
  }

  &:focus {
    color: @font-primary-color;
  }

  &.disabled {
    background-image: url('../../assets/image/bg-button-disabled@pss.jpg');
    cursor: no-drop;

    &:hover {
      background-image: url('../../assets/image/bg-button-disabled@pss.jpg');
    }

    > span {
      background-image: url('../../assets/image/bg-button-disabled@pss.jpg');

      &:hover {
        background-image: url('../../assets/image/bg-button-disabled@pss.jpg');
      }
    }
  }

  > span {
    display: inline-block;
    padding: 0 30px;
    height: 100%;
    background: url('../../assets/image/bg-button@pss.jpg') right 0;
    font-weight: bold;
    font-size: 12px;

    &:hover {
      background-image: url('../../assets/image/bg-button-hover@pss.jpg');
    }
  }
}
</style>
